import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

export default function QuienSomos() {
  return (
    <div>
      <div className="quienes_somos_title">
        <h1>
          "HAZLO UNA <br />
          SOLA VEZ"
        </h1>
        <h2>DAMIRE</h2>
      </div>
      <div className="quienes_somos_primary">
        <div className="quienes_somos_end">
          <h1>Misión.</h1>
          <p>
            Desarrollar vínculos sólidos a largo plazo con nuestros clientes,
            ofreciéndoles soluciones adecuadas a sus necesidades técnicas y
            económicas.
          </p>
        </div>

        <div className="quienes_somos_verticalLine"></div>

        <div className="quienes_somos_start">
          <h1>Visión.</h1>
          <p>
            Ser una compañía de excelencia en proporcionar soluciones
            sustentables y servicios de construcción civil, mecánica,
            electromecánica y de mantenimiento en México
          </p>
        </div>
      </div>
    </div>
  );
}
